import type { Guide } from '../types';

/**
 * S-04.11-01 — Transporeon, wyłącznie pobieranie (decyzje Bartka 04.11.2026; scenariusz e2e 46). Kroki
 * pokazują ekran administracyjny i konto interfejsu na ekranie poświadczeń — nagrywarka niczego nie zapisuje
 * ani nie importuje. Alerty przy zleceniu opisuje tekst (dane pokazowe nie mają komunikatów z Transporeonu,
 * dopóki ktoś nie zaimportuje kopii).
 */
export const guide: Guide = {
  flagKey: 'transporeonImport',
  title: 'Transporeon: komunikaty z kolejki i alerty',
  whatItDoes:
    'Komunikaty z kolejki przewoźnika w Transporeonie — wyłącznie pobieranie, nic nie wysyłamy (bez ofert, cen i statusów). Kolejkę czyta tylko produkcja i potwierdza pobranie dopiero po zapisie w bazie; staging dostaje kopię komunikatów z produkcji. Transporty dopasowujemy do zleceń z TMS po numerze (dzień załadunku ±2 dni, kod pocztowy). Przy zleceniu z TMS planista FTL (a przy zleceniu w Trade także Trade) dostaje alert ze źródłem Transporeon: zmiana okna, miejsca, trasy albo wagi, anulacja („Potwierdzam anulację — zwolnij auto” albo „To nie anulacja”, jak przy TMS) i ponowne wystawienie pod tym samym numerem. Karta zlecenia ma sekcję „Transporeon”. Transport przyjęty w Transporeonie, którego po godzinie nie ma w TMS, jest oznaczony na ekranie „Transporeon” i liczony na kafelku „Transporeon — brak w TMS” pulpitów FTL (lista tylko do odczytu).',
  audience: ['administrator', 'FTL', 'Trade'],
  presentationItems: ['S-04.11-01'],
  steps: [
    {
      route: '/transporeon',
      target: 'transporeon-summary',
      title: 'Stan pobierania i raport',
      description:
        'Czy to produkcja i co ile pobieramy, czy pobranie jest potwierdzane, ile komunikatów i ile transportów bez zlecenia w TMS. Pod spodem raport pobrań: ile komunikatów (nowych), ile alertów, potwierdzenie i błędy. Na stagingu zamiast kolejki — import kopii komunikatów z produkcji.',
      action: 'Otwórz „Transporeon” w menu (grupa „Administracja”).',
      recorder: { account: 'admin' },
    },
    {
      route: '/transporeon',
      target: 'transporeon-filter-missing',
      title: 'Brak w TMS i dopasowanie',
      description:
        'Transporty z dopasowaniem do TMS: „jest w TMS”, „kilka zleceń w TMS” (ponowne wystawienie — możliwy duplikat w banku), „numer jest, dane się nie zgadzają” i „Przyjęte w Transporeonie, brak w TMS” — po godzinie od przyjęcia. „Surowe komunikaty” pokazują dokładnie to, co przyszło — tylko w sekcji administracyjnej.',
      action: 'Kliknij filtr „Brak w TMS”.',
      recorder: { account: 'admin', actions: [{ kind: 'click', target: 'transporeon-filter-missing' }] },
    },
    {
      route: '/ftl-planner-dashboard',
      target: 'ftl-tile-transporeonMissingInTms',
      title: 'Kafelek „Transporeon — brak w TMS”',
      description:
        'Na pulpicie planisty (w sekcji „Zlecenia”) i na pulpicie Team Leadera (w sekcji „Wymaga uwagi”): ile transportów przyjętych w Transporeonie nadal nie ma w TMS po godzinie — dla spółki konta, a konto bez spółki widzi sumę z rozbiciem na spółki. Ta sama reguła co filtr „Brak w TMS” na ekranie administracyjnym. Gdy dane są starsze niż godzina — dopisek „Dane z Transporeonu z dnia …”.',
      action: 'Otwórz „Pulpit planisty” w menu.',
      recorder: { account: 'ftl' },
    },
    {
      route: '/transporeon-missing',
      target: 'transporeon-missing-screen',
      title: 'Lista dla FTL — tylko do odczytu',
      description:
        'Spółka, zleceniodawca, numer z Transporeonu, relacja, okno załadunku (czas polski) i od kiedy transportu brak w TMS; filtr „Spółka” — domyślnie spółka konta (z kafelka ta sama). Bez surowych komunikatów i danych dyspozytorów — te widzi tylko sekcja administracyjna. Transport znika, gdy pojawi się w TMS, zostanie anulowany albo minie jego okno.',
      action: 'Kliknij kafelek „Transporeon — brak w TMS”.',
      recorder: { account: 'ftl' },
    },
    {
      route: '/credentials',
      target: 'transporeon-credentials',
      title: 'Konto interfejsu spółki',
      description:
        'Użytkownik, id spółki i hasło interfejsu przewoźnika (opcjonalnie client id) dla wybranej spółki — tylko zapis, do zaszyfrowanego magazynu. Na start tylko spółka polska. Pobieranie i tak rusza wyłącznie na produkcji, z cyklem w konfiguracji wdrożenia.',
      action: 'Otwórz „Poświadczenia” w grupie „Administracja”.',
      recorder: { account: 'admin' },
    },
  ],
};
